<div class="relative flex items-center justify-center w-full lg:flex-col">
  <img 
    loading="lazy"
    fetchpriority="low"
    class="slow-bounce absolute left-[2rem] top-[55%] h-[4.6rem] lg:top-[14%] lg:left-[7%]" src="/assets/images/vip/wave.webp" 
    alt="vip_wave">
  <img 
    loading="lazy"
    fetchpriority="low"
    class="slow-bounce absolute left-[45%] bottom-[10%] h-[7.4rem] z-[3] lg:hidden" src="/assets/images/vip/wave-2.webp" 
    alt="vip_wave2">
  <img 
    loading="lazy"
    fetchpriority="low"
    class="orbita-animation absolute left-[46.5%] top-[15%] h-[3.6rem] z-[3] lg:top-[2.5%] lg:left-auto lg:right-[16%]" src="/assets/images/vip/diamond-2.webp" 
    alt="vip-diamond-2">
  <img 
    loading="lazy"
    fetchpriority="low"
    class="slow-bounce absolute left-[40%] top-[10%] h-[2.4rem] z-[3] lg:top-[16%] lg:left-auto lg:right-[5%]" src="/assets/images/vip/round.webp" 
    alt="vip-round">
  <img 
    loading="lazy"
    fetchpriority="low"
    class="slow-bounce absolute bottom-[27.5%] right-[6%] h-[1.6rem] z-[3] lg:hidden" src="/assets/images/vip/round.webp" 
    alt="vip-round">
  <div class="flex flex-col space-y-[2.2rem] pt-[7.6rem] h-full mr-[-10.3rem] lg:pt-0 lg:mt-[-20.25rem] lg:mr-0 lg:order-2 lg:w-full lg:px-[1.5rem]">
    <div class="flex items-center pl-[2rem] space-x-[1.5rem] lg:pl-0 lg:absolute lg:top-0 lg:space-x-[0.6rem]">
      <i class="text-[5.4rem] icon icon_diamond lg:text-[2.2rem]"></i>
      <span class="leading-normal text-white text-[4.8rem] font-450 lg:text-[2rem] lg:leading-[2.6rem]" i18n="@@vip_page.title">VIP Клуб </span>
      <div class="flex items-center justify-center py-[1.1rem] px-[1.4rem] rounded-[2rem] bg-[linear-gradient(22deg,#FABF41_10.81%,#B77D2B_85.59%)] lg:px-[1rem] lg:py-[0.6rem] lg:!ml-[0.8rem]">
        <span class="text-dark-extra text-[1.3rem] font-400 leading-[1.8rem] lg:text-[1.2rem] lg:leading-[1.4rem]" i18n="@@vip_page.title.soon">Cкоро</span>
      </div>
    </div>
    <div class="grid grid-cols-[35.9rem_auto] gap-[1.4rem] lg:gap-[0.7rem] lg:grid-cols-1 lg:w-full">
      <div class="flex items-end justify-end gap-[1.4rem] lg:gap-[0.7rem] lg:pl-0 lg:w-full">
        <div 
          class="card-bg flex flex-col relative overflow-hidden p-[2rem] backdrop-blur-[1.2rem] rounded-[1.2rem] bg-[rgba(46,30,90,0.70)] w-[16.3rem] h-[18.8rem] bg-[url('assets/images/vip/cashback.webp')] lg:w-full lg:flex-1">
          <span class="leading-normal text-[1.5rem] font-400 text-white" i18n="@@vip_page.card.hide_cashback">Повышенный кэшбек</span>
        </div>
        <div class="card-bg flex flex-col relative overflow-hidden p-[2rem] backdrop-blur-[1.2rem] rounded-[1.2rem] bg-[rgba(46,30,90,0.70)] w-[16.3rem] h-[18.8rem] bg-[url('assets/images/vip/lose-cashback.webp')] lg:w-full lg:flex-1">
          <img class="w-full absolute top-0 right-[-1.3rem] z-[2] pointer-events-none" src="/assets/images/vip/secret.webp" alt="vip-card-secret">
        </div>
      </div>
      <div class="flex items-end gap-[1.4rem] lg:gap-[0.7rem] lg:w-full">
        <div 
          class="card-bg flex flex-col relative overflow-hidden p-[2rem] backdrop-blur-[1.2rem] rounded-[1.2rem] bg-[rgba(46,30,90,0.70)] w-[16.3rem] h-[21.2rem] bg-[url('assets/images/vip/service.webp')] lg:w-full lg:flex-1">
          <span class="text-[1.5rem] font-400 text-white" i18n="@@vip_page.card.service">Сервис</span>
          <span class="leading-normal mt-[0.8rem] text-[1.3rem] font-325 text-[rgba(232,232,255,0.80)]" i18n="@@vip_page.card.service_desc">Приоритетная обработка обращений в поддержку</span>
        </div>
        <div 
          class="card-bg flex flex-col relative overflow-hidden p-[2rem] backdrop-blur-[1.2rem] rounded-[1.2rem] bg-[rgba(46,30,90,0.70)] w-[16.3rem] h-[18.8rem] bg-[url('assets/images/vip/secret-percent.webp')] lg:h-[21.2rem] lg:w-full lg:flex-1">
          <span class="leading-normal text-[1.5rem] font-400 text-white" i18n="@@vip_page.card.bet_insurance">Страховка ставки</span>
        </div>
      </div>
    
      <div class="relative flex items-start gap-[1.4rem] lg:gap-[0.7rem] lg:w-full lg:order-2">
        <div 
          class="card-bg col-span-2 flex flex-col relative overflow-hidden p-[2rem] backdrop-blur-[1.2rem] rounded-[1.2rem] bg-[rgba(46,30,90,0.70)] w-[35.9rem] h-[18.8rem] bg-[url('assets/images/vip/manager.webp')] lg:w-full">
          <span class="leading-normal text-[1.5rem] font-400 text-white max-w-[20.8rem] w-full" i18n="@@vip_page.card.manager">Персональный менеджер и подключение general manager к решению проблем</span>
        </div>
        <img 
          loading="lazy"
          fetchpriority="low"
          class="orbita-animation absolute bottom-[-2.6rem] left-[21.5%] h-[6.9rem]" src="/assets/images/vip/diamond.webp" alt="vip-diamond">
      </div>
      <div class="flex items-start gap-[1.4rem] lg:gap-[0.7rem] lg:w-full lg:order-1">
        <div 
          class="card-bg flex flex-col relative overflow-hidden p-[2rem] backdrop-blur-[1.2rem] rounded-[1.2rem] bg-[rgba(46,30,90,0.70)] w-[16.3rem] h-[21.2rem] bg-[url('assets/images/vip/chat.webp')] lg:h-[18.8rem] lg:w-full lg:flex-1 lg:order-2">
          <span class="leading-normal text-[1.5rem] font-400 text-white" i18n="@@vip_page.card.close_chat">Закрытый VIP чат</span>
        </div>
        <div 
          class="card-bg flex flex-col relative overflow-hidden p-[2rem] backdrop-blur-[1.2rem] rounded-[1.2rem] bg-[rgba(46,30,90,0.70)] w-[16.3rem] h-[18.8rem] bg-[url('assets/images/vip/bonuses.webp')] lg:w-full lg:flex-1 lg:order-1">
          <span class="leading-normal text-[1.5rem] font-400 text-white" i18n="@@vip_page.card.bonuses">Персональные бонусы и акции</span>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-shrink-0 mr-[-19rem] mt-[-7.6rem] lg:mt-[-6rem] lg:mr-0 lg:order-1">
  <img class="right-0 h-[82.6rem] w-full lg:h-[48rem] lg:w-[45.4rem] pointer-events-none lg:min-w-[45.4rem]" src="/assets/images/vip/character.webp" alt="">
  </div>
  <img 
    loading="lazy"
    fetchpriority="low"
    src="/assets/images/vip/gradient-light.webp" 
    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[-1] w-full h-full pointer-events-none lg:hidden"
    alt="vip-back-gradient"
    />
  <img 
    loading="lazy"
    fetchpriority="low"
    src="/assets/images/vip/gradient-light-mob.webp" 
    class="absolute top-[-10%] left-1/2 -translate-x-1/2 z-[-1] h-[52.5rem] w-[100vw] hidden lg:block pointer-events-none"
    alt="vip-back-gradient-mobile"/>
</div>